import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getVoucher } from 'Services/Features/Voucher/Utils/voucherUtils';
import CustomLoader from 'Component/Common/CustomLoader';
import FindVoucher from './Filter/FindVoucher';
import VoucherContent from './VoucherContent';
import {
    handleNextPagination,
    handleBackPagination,
    handleClickPagination
} from 'Component/DashboardQeza/Common/PaginationUtils';
import PaginationComponent from 'Component/Common/PaginationComponent';
import { setFilters } from 'Services/Features/Voucher/voucherSlice';

const VoucherContain = () => {
    const dispatch = useDispatch();
    const vouchers = useSelector((state) => state.voucher.vouchers);
    const loading = useSelector((state) => state.voucher.loading);
    const error = useSelector((state) => state.voucher.error);
    const [refetch, setRefetch] = useState(false);
    const pagination = useSelector((state) => state.voucher.pagination);
    const filters = useSelector(state => state.voucher.filters);

    useEffect(() => {
        dispatch(getVoucher(filters));
        window.scrollTo(0, 0);
    }, [dispatch, refetch]);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Fragment>
            <Col md="12" className="project-list">
                <Card className="px-3">
                    <FindVoucher />
                </Card>
            </Col>
            <Col xl="12" className="xl-80">
                <Row>
                    {loading ? (
                        <CustomLoader />
                    ) : loading === false && vouchers.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <h5 style={{ fontSize: '24px' }}>Voucher Tidak Ditemukan</h5>
                            </div>
                        </Col>
                    ) : (
                        <Col sm="12">
                            <VoucherContent setRefetch={setRefetch} />
                        </Col>
                    )}
                </Row>
                <div style={{ marginTop: '150px' }}>
                    {loading === false && vouchers && vouchers.length > 0 && (
                        <PaginationComponent
                            pagination={pagination}
                            handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                            handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefetch)}
                            handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefetch)}
                        />
                    )}
                </div>
            </Col>
        </Fragment>
    );
};

export default VoucherContain;